import React, {useEffect, useState} from 'react';
import { Link, withRouter } from "react-router-dom";
import { ContainerStyled } from './style';
import MainLayout from 'components/main-layout/main-layout';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrashAlt, faListUl, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import indicacoesService from 'services/indicacao-especial-service/indicacao-especial-service';
import bolsasService from 'services/bolsas/bolsas-service';
import tipoProdutoService from 'services/tipo-produto/tipo-produto-service';
import { Bolsa } from "../../models/bolsa";
import { Indicacao } from "../../models/indicacoes";
import { TipoProduto } from "../../models/tipo-produto";
import VerDetalhesModal from "modals/ver-detalhes-modal";
import DeletarIndicacaoModal from "../../modals/deletar-indicacao-modal";
import ExpressUtils from 'utils/express-utils';
import SortUtils from 'utils/sort-utils';
import {cpfMask} from 'utils/cpf-utils';
import Loader from 'components/UI/loader/loader';
import DropdownSimple from 'components/UI/dropdown-simple/dropdown-simple';
import {getFormattedDate} from "../../utils/date-utils";
import Pagination from 'components/Pagination/Pagination';

function Historico() {
  const [bolsas, setBolsas] = useState<Bolsa[]>([]);
  const [bolsa, setBolsa] = useState<Bolsa>();
  const [indicacaoDetalhes, setIndicacaoDetalhes] = useState<Indicacao>();
  const [indicacoes, setIndicacoes] = useState<Indicacao[]>([]);
  const [tipos, setTipos] = useState<TipoProduto[]>([]);
  const [tipo, setTipo] = useState<TipoProduto>();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [loader, setLoader] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalIndications, setTotalIndications] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(()=>{
    bolsasService.getUsuarioIesBolsas().then(resp => {
      SortUtils.sortBolsas(resp);
      setBolsas(resp);
    }).catch(err => {
      console.log(err);
    });
  }, []);

  useEffect(()=>{
    setIndicacoes([]);
    if(bolsa?.id){
      setLoader(true);
      indicacoesService.getIndicacoes(bolsa.id, currentPage, cpf, nome).then(resp => {
        setIndicacoes(resp.indicacoes);
        setTotalIndications(resp.elementos);
        setTotalPages(resp.paginas);
        setIsFirstTime(true);
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
      });
      tipoProdutoService.getTipoProduto().then(resp => {
        setTipos(resp);
      }).catch(err =>{
        console.log(err);
      })
    }
  }, [bolsa, currentPage]);

  const onChange = (target) => {
    const ie = bolsas.find(value =>  value.id == target);
    setBolsa(ie);
  }

  const onChangeTipo = (target) =>{
    const solucao = tipos.find(value => value.id == target);
    setTipo(solucao)
  }

  const onClickDetalhes = (id) => {
    const indicacao = indicacoes.filter(value => {return value.id == id})
    setIndicacaoDetalhes(indicacao[0]);
    setModalOpen(true);
  }

  const onClickDelete = (id) =>{
    if(id){
      const indicacao = indicacoes.filter(value => {return value.id == id})
      setIndicacaoDetalhes(indicacao[0]);
      setDeleteModalOpen(true);
    }
  }

  const onClickBuscar = () => {
    setIsFirstTime(true);
    if(bolsa?.id){
      setLoader(true);
      indicacoesService.getIndicacoes(bolsa.id, 1, cpf, nome, tipo?.nome)
        .then(resp => {
          setIndicacoes(resp.indicacoes);
          setLoader(false);
          setTotalIndications(resp.elementos);
          setTotalPages(resp.paginas);
          setCurrentPage(1);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  const onDelete = (id) =>{
    setDeleteModalOpen(false);
    setIndicacoes(indicacoes.filter(value=> {return value.id !== id}));
  }

  return (
    <MainLayout>
      <ContainerStyled>
        <Container>
          <Row><Link className="btn-voltar-title" to="/indicacao-especial"><FontAwesomeIcon icon={faArrowLeft} />&nbsp;Voltar para indicação especial</Link></Row>
          <Row><h2>Histórico de indicação especial</h2></Row>

          <Form onSubmit={(e) => {e.preventDefault()}}>
            <Form.Row>
              <Col md={4}>
                <Form.Label></Form.Label>

                <DropdownSimple
                  className="select-padrao"
                  items={bolsas.map(bolsa => ({id: bolsa.id + '', label: `${bolsa?.sigla} - ${bolsa?.solucao}`}))}
                  label={bolsa ? `${bolsa?.sigla} - ${bolsa?.solucao}` : "Selecione o convênio"}
                  onItemClicked={id => onChange(id)}
                />
              </Col>
              <Col>
                <Form.Label></Form.Label>
                <DropdownSimple
                  className="select-padrao"
                  items={tipos.map(t => ({id: t.id + '', label: t.nome}))}
                  label={tipo ? tipo.nome : "Selecione a solução"}
                  onItemClicked={id => onChangeTipo(id)} />
              </Col>
              <Col md={3}>
                <Form.Label>CPF</Form.Label>
                <Form.Control type="text" placeholder="" onChange={e => {setCpf(e.target.value)}}/>
              </Col>
              <Col md={3}>
                  <Form.Label>Nome</Form.Label>
                  <Form.Control type="text" placeholder=""  onChange={e => {setNome(e.target.value)}}/>
              </Col>
              <Col md={2}>
                <Button className="btn-search" variant="primary" onClick={onClickBuscar}><FontAwesomeIcon icon={faSearch} />Buscar</Button>
              </Col>
            </Form.Row>
          </Form>

          <Loader show={loader} />

          {!loader && !totalIndications && isFirstTime &&
            <div className="txt-resultado-busca">
              <h3>Sua busca não obteve resultado!</h3>
              <p>Tente novamente utilizando outros filtros</p>
            </div>
          }

          {!loader && indicacoes.length > 0 &&
            <>
              <div className="header-list">
                <Row>
                  <Col md={2}>Convênio</Col>
                  <Col md={2}>CPF</Col>
                  <Col md={3}>Nome</Col>
                  <Col md={1}>Solução</Col>
                  <Col md={1}>Data de indicação</Col>
                  <Col md={3}></Col>
                </Row>
              </div>

              <ListGroup>
                {indicacoes.map((e, key) => {
                    return (
                      <ListGroup.Item key={key}>
                        <Row>
                          <Col md={2}>{`${e.bolsa?.sigla} - ${e.bolsa?.solucao}`}</Col>
                          <Col md={2}>{cpfMask(e.cpf)}</Col>
                          <Col md={3}>{e.nome}</Col>
                          <Col md={1}>{e.bolsa?.solucao} {e.tipoProduto === 'EXPRESS' ? e.tipoProduto : ''}</Col>
                          <Col md={1}>{getFormattedDate(e.dataInsercao)}</Col>
                          <Col md={3} className="talign-right">
                            <a onClick={()=>{onClickDetalhes(e.id);}}><FontAwesomeIcon icon={faListUl} />Ver detalhes</a> 
                            <a onClick={()=>{onClickDelete(e.id);}}><FontAwesomeIcon icon={faTrashAlt} />Apagar</a>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    );
                })}
              </ListGroup>
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalIndications={totalIndications}
                totalPages={totalPages}
              />
            </>
          }
        </Container>
      </ContainerStyled>
      <VerDetalhesModal
        isOpen={isModalOpen}
        onClose={() => {setModalOpen(false);}}
        indicacao={indicacaoDetalhes}
        bolsa={bolsa}
      />
      <DeletarIndicacaoModal
        isOpen={isDeleteModalOpen}
        onClose={()=>{setDeleteModalOpen(false);}}
        onDelete={onDelete}
        indicacao={indicacaoDetalhes}
        isExpress={ExpressUtils.isExpress(indicacaoDetalhes)}
      />    
    </MainLayout>
  );
};

export default withRouter(Historico);
